import { Box, keyframes, Typography, useMediaQuery, useTheme } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

// Horizontal scroll animation
const scrollHorizontal = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const EmergencyBanner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const message = (
    <>
      <WarningIcon sx={{ color: 'white', mr: 1 }} />
      <Typography component="span" sx={{
          fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' }, // smaller on phone
        }}>
        If you are in crisis, call 988. If you are experiencing a medical emergency, 
        call 911 immediately or go to the nearest emergency room.
      </Typography>
    </>
  );

  return (
    <Box
      sx={{
        width: '100%',
        height: 40,
        overflow: 'hidden',
        bgcolor: 'black',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          whiteSpace: 'nowrap',
          animation: `${scrollHorizontal} ${isMobile ? 25 : 50}s linear infinite`,
          color: 'white',
          fontWeight: 'bold',
        }}
      >
        {/* Duplicate the message twice for seamless looping */}
        <Box sx={{ display: 'flex', alignItems: 'center', pr: 8 }}>{message}</Box>
        <Box sx={{ display: 'flex', alignItems: 'center', pr: 8 }}>{message}</Box>
      </Box>
    </Box>
  );
};

export default EmergencyBanner;
